import { createContext, useContext } from "react";
import {
  BodypartType,
  ExerciseAssetSort,
  ExerciseAssetType,
  MovementPatternType,
} from "@growth-machine-llc/stridist-api-client";

export const ALL_OPTIONS = "ALL" as const;

export type ALL_OPTIONS_TYPE = typeof ALL_OPTIONS;

export interface ExerciseListFilterContextValues {
  query: string;
  sortKey: ExerciseAssetSort;
  bodyparts: BodypartType[] | ALL_OPTIONS_TYPE;
  movementPatterns: MovementPatternType[] | ALL_OPTIONS_TYPE;
  exerciseType: ExerciseAssetType;
  tagIds: number[] | ALL_OPTIONS_TYPE;
  handleTagIdsChange: (tagIds?: number[], allOptionsSelected?: boolean) => void;
  handleQueryChange: (query: string) => void;
  handleSortKeyChange: (sortKey: ExerciseAssetSort) => void;
  handleBodypartChange: (bodyparts: BodypartType[]) => void;
  handleMovementPatternChange: (
    movementPatterns: MovementPatternType[],
  ) => void;
}

export const ExerciseListFilterContext = createContext<
  ExerciseListFilterContextValues | undefined
>(undefined);

export const useExerciseListFilterContext = () => {
  return useContext(ExerciseListFilterContext);
};
